import { useMemo } from "react";
import { useDeviceType } from "@b2bportal/core-utilities";
import { CheckoutMapComponent } from "@checkout/CheckoutComponent";
import { FlightExchangeState, ParentState } from "@checkout/types";
import {
  FlightExchangeCartQuote,
  FlightExchangeReviewPage,
  LoadingScreen,
  PaymentPage,
  SinglePageCheckout,
} from "@hsbc/flights";
import {
  FlightExchangeConfirmation,
  FlightExchangeManualRebook,
  FlightExchangeRebook,
} from "@tenant/flights";

export const FlightExchangeCheckoutComponent = () => {
  const { isDesktopAndUp } = useDeviceType();

  const exchangeComponentMap = useMemo(
    () => ({
      [ParentState.loading]: {
        state: ParentState.loading,
        component: LoadingScreen,
      },
      [ParentState.cartQuote]: {
        state: ParentState.cartQuote,
        component: FlightExchangeCartQuote,
      },
      [ParentState.cardPayment]: {
        state: ParentState.cardPayment,
        component: PaymentPage,
      },
      [ParentState.review]: {
        state: ParentState.review,
        component: FlightExchangeReviewPage,
      },
      [ParentState.cartFulfill]: {
        state: ParentState.cartFulfill,
        component: FlightExchangeRebook,
      },
      [FlightExchangeState.cartRebookFailed]: {
        state: FlightExchangeState.cartRebookFailed,
        component: FlightExchangeManualRebook,
      },
      [ParentState.bookingConfirmation]: {
        state: ParentState.bookingConfirmation,
        component: FlightExchangeConfirmation,
      },
    }),
    []
  );

  if (isDesktopAndUp) {
    return <SinglePageCheckout />;
  }

  return <CheckoutMapComponent componentMap={exchangeComponentMap} />;
};
